
{
  "fr": {
    "separator": ", "
  }
}
